<template>
  <div pageE>
    <article class="wrapper">
      <div class="cover">
        <div class="cont">
          <div class="begin" v-if="step === 0 || env ==='mob'">
            <ul>
              <li v-for="(t,id)  in pcSlide" :key="id"  :class="{on: step-1 === id }">
                <p class="name"></p>
                <p class="thumb"></p>
                <a @click="setChangeStep(id+1)"></a>
              </li>
            </ul>
          </div>
          <slider ref="slide" :option="option" :pagination="false" :navigation="false">
            <div class="swiper-slide" :class="`item${id}`" v-for="(item,id) in pcSlide" :key="id">
              <div class="list">
                <article>
                  <ul class="ts" @mouseleave="setBgReset(-1)">
                    <li v-for="(t,id) in item.items" :key="id" :class="{on : id === activeId, off : id !== activeId && activeId > -1}">
                      <a :style="{backgroundImage:`url('${getImage(t.thumb)}')`}" @mouseenter="setBgReset(id)" @click="setBgReset(id)"></a>
                    </li>
                  </ul>
                  <p class="desc" :style="{backgroundImage:`url('${getImage(item.desc)}')`}"></p>
                </article>
              </div>
              <p class="bg" :style="{backgroundImage:`url('${getImage(item.activeBg)}')`}" ></p>
            </div>
            <ul class="page-bts" v-if="env === 'mob'">
              <li><a @click="goNext(false)"></a></li>
              <li><a @click="goNext(true)"></a></li>
            </ul>
          </slider>
        </div>
      </div>
      <ul class="page-bts" v-if="env === 'pc'">
        <li><a @click="goNext(false)"></a></li>
        <li><a @click="goNext(true)"></a></li>
      </ul>
    </article>
    <article class="tab-bts">
      <ul>
        <li :class="{on:step===1}"><a @click="setChangeStep(1)"></a></li>
        <li :class="{on:step===2}"><a @click="setChangeStep(2)"></a></li>
        <li :class="{on:step===3}"><a @click="setChangeStep(3)"></a></li>
        <li :class="{on:step===4}"><a @click="setChangeStep(4)"></a></li>
      </ul>
    </article>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import Slider from '../components/Slider.vue';

export default {
  name: 'pageE',
  components: { Slider },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  watch: {
    $route() {
      this.reset();
    },
    env() {
      return this.$store.state.environment;
    },
  },
  data() {
    return {
      step: 0,
      activeId: -1,
      imgUrl: '/static/img/',
      option: {
        loop: false,
        touchRatio: 0,
        effect: 'fade',
        on: {
          slideChange: this.slideChange,
        },
      },
      pcSlide: [
        {
          activeBg: 'bg2.jpg', bg: 'bg2.jpg', img: 'c2.png', mov: '', thumb: 'thumb1.png', desc: 'c1-disc.png', items: [{ thumb: 'c1-t1.png', img: 'c1-img1.png' }, { thumb: 'c1-t2.png', img: 'c1-img2.png' }, { thumb: 'c1-t3.png', img: 'c1-img3.png' }],
        },
        {
          activeBg: 'bg3.jpg', bg: 'bg3.jpg', img: 'c3.png', mov: '', thumb: 'thumb2.png', desc: 'c2-disc.png', items: [{ thumb: 'c2-t1.png', img: 'c2-img1.png' }, { thumb: 'c2-t2.png', img: 'c2-img2.png' }, { thumb: 'c2-t3.png', img: 'c2-img3.png' }],
        },
        {
          activeBg: 'bg4.jpg', bg: 'bg4.jpg', img: 'c4.png', mov: '', thumb: 'thumb3.png', desc: 'c3-disc.png', items: [{ thumb: 'c3-t1.png', img: 'c3-img1.png' }, { thumb: 'c3-t2.png', img: 'c3-img2.png' }, { thumb: 'c3-t3.png', img: 'c3-img3.png' }],
        },
        {
          activeBg: 'bg5.jpg', bg: 'bg5.jpg', img: 'c4.png', mov: '', thumb: 'thumb4.png', desc: 'c4-disc.png', items: [{ thumb: 'c4-t1.png', img: 'c4-img1.png' }, { thumb: 'c4-t2.png', img: 'c4-img2.png' }, { thumb: 'c4-t3.png', img: 'c4-img3.png' }],
        },
      ],
    };
  },
  methods: {
    reset() {
      if (this.env === 'pc' && this.$route.name === 'class' && !this.$route.query.code) {
        this.setChangeStep(0);
        return;
      }
      if (this.$route.name === 'class' && this.$route.query.reset === 'Y' && this.$refs.slide) {
        let c = (Number(this.$route.query.code)) || this.step;
        c = c > this.pcSlide.length - 1 ? this.pcSlide.length - 1 : c < 0 ? 0 : c;
        this.setChangeStep(this.$route.query.code || this.step);
      }
    },
    goNext(next) {
      let step = 0;
      if (this.env === 'mob' && this.step === 0 && next) {
        step = 2;
      } else {
        step = this.step + (next ? 1 : -1);
        step = next && step > this.pcSlide.length ? 1 : !next && step < 1 ? this.pcSlide.length : step;
        step %= (this.pcSlide.length + 1);
      }

      this.setChangeStep(step);
    },

    getBg() {
      return `${this.imgUrl}${this.env}/p5/bg${this.step}.jpg`;
    },
    getImage(item) {
      return `${this.imgUrl}${this.env}/p5/${item}`;
    },
    setChangeStep(id) {
      // if (this.step === Number(id)) return;
      const bId = this.step;
      this.$refs.slide.goToSlide(id - 1);
      this.step = Number(id);
      this.activeId = -1;

      if (this.$route.name === 'class') { this.$router.replace(`class?code=${this.step}&reset=Y`); }
      if (id > 0 && this.env === 'mob' && Number(id) !== bId) {
        const target = $('#class .swiper-container');
        const offset = target.offset().top;
        $(window).scrollTop(offset);
      }
    },

    slideChange() {
      this.step = this.$refs.slide.now();
      this.setBgReset(-1);
    },

    setBgReset(id) {
      if (this.step === 0 && this.env === 'pc') return;
      const aId = this.step === 0 ? 0 : this.step - 1;
      this.activeId = id;
      this.pcSlide[aId].activeBg = id === -1 ? this.pcSlide[aId].bg : this.pcSlide[aId].items[id].img;

      const clone = _.clone(this.pcSlide);
      this.pcSlide = clone;
    },
  },
};
</script>

<style lang="less">
  @import '../less/proj';
  .mob{
    [pageE]{.rel;  .w(100%); .bg-x(50%);
      >.wrapper{.wh(100%);
        .cover{.wh(100%);
          .cont{.wh(100%);
            .swiper-container{.wh(100%,1600);
              .swiper-wrapper{.wh(100%);
                .swiper-slide{ background: black; .wh(100%);
                  .bg{.cover; .wh(100%); .abs; .t(0); transition: .5s;}

                  article{.abs; .w(100%);  .b(550); z-index: 100;
                    .ts{ .ib-list;  white-space: nowrap;  .w(700); .ml(-350); .l(50%); .abs; .t(170);
                      li{ .wh(33.3%,400px);  transition: .5s; opacity: .5;
                        a{.block; .wh(100%); .contain; .no-repeat;}
                        &.on{opacity: 1;}
                      }
                    }
                    .desc{.wh(600,260); .contain; .no-repeat; .mh-c;
                      &:nth-of-type(2){}
                    }
                  }

                  &.item3{
                    article{
                      .ts{ .t(220);
                      }
                    }
                  }
                }
              }
            }
            .begin{ .pt(130); .pb(170); .h(1420); .-box; .cover("@{mob}/p5/bg1.jpg");
              ul{ .ib-list;  .tc; z-index:10;
                &:before{.cnt; .contain("@{mob}/p5/title.png"); .wh(186,75); .mh-c; .mb(65);}
                li{.rel; .wh(280,360); .no-repeat; box-shadow: 0 10px 10px 5px rgba(0,0,0,0.6); .m(18,20);
                  .name{.wh(100%); overflow: hidden;.abs; .wh(150,80); .no-repeat; transition: .5s; z-index: 10; .b(30); .l(50%); .ml(-75); pointer-events: none;}
                  .thumb{.wh(100%); overflow:hidden; .abs; &:before{.cnt; .abs; .wh(100%); .bg-c; transition:.5s; .l(50%); .t(50%); transform: translate(-50%,-50%); .no-repeat;}}
                  &:nth-of-type(1){
                    .thumb{ &:before{.contain("@{mob}/p5/thumb1.png");}}
                    .name{.contain("@{mob}/p5/name1.png");}
                  }
                  &:nth-of-type(2){
                    .thumb{ &:before{.contain("@{mob}/p5/thumb2.png");}}
                    .name{.contain("@{mob}/p5/name2.png");}
                  }
                  &:nth-of-type(3){
                    .thumb{ &:before{.contain("@{mob}/p5/thumb3.png");}}
                    .name{.contain("@{mob}/p5/name3.png");}
                  }
                  &:nth-of-type(4){
                    .thumb{&:before{.contain("@{mob}/p5/thumb4.png");}}
                    .name{.contain("@{mob}/p5/name4.png");}
                  }
                  a{.block; .wh(100%);.rel; opacity:0;  transition: .5s; .-box;
                    &:before{.cnt; .wh(68,46); .contain("@{pc}/thumb-on-effect.png"); .abs; .t(-25); .l(100); opacity: 0; transition: .5s;}
                    &:after{.cnt; .wh(68,46); .contain("@{pc}/thumb-on-effect.png"); .abs; .b(-23); .r(100); opacity: 0; transition: .5s;}
                  }
                  &.on{
                    .thumb{&:before{.wh(110%);}}
                    a{ opacity:1; .-a(#FF0000);
                      &:before{.l(10); opacity: 1;}
                      &:after{.r(10); opacity: 1;}
                    }
                  /*  &:nth-of-type(1){
                      .name{ .bg("@{pc}/p5/name1-on.png");}
                    }
                    &:nth-of-type(2){
                      .name{ .bg("@{pc}/p5/name2-on.png");}
                    }
                    &:nth-of-type(3){
                      .name{ .bg("@{pc}/p5/name3-on.png");}
                    }
                    &:nth-of-type(4){
                      .name{ .bg("@{pc}/p5/name4-on.png");}
                    }*/
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .pc{
    [pageE]{.fix; .cover; .bg-x(50%); .wh(100%); .-box; .min-h(100%); .-box; .min-w(1140px); .cover("@{pc}/p5/bg1.jpg"); transition: .5s;
      >.wrapper{.wh(100%);
        .cover{.wh(100%); .rel; overflow:hidden; -webkit-overflow-scrolling: touch;
          .cont{ .rel; .wh(100%); overflow:hidden; .min-h(900px);
            .swiper-container{ .wh(100%);  .min-w(1140px);
              .swiper-wrapper{.wh(100%);
                .swiper-slide{ .wh(100%); .rel;opacity: 0; background: black;
                  .bg{.wh(100%);.abs; .t(0); transition: .5s;}
                  article{.abs; .r(20%); .w(35%);  .t(50%); transform: translateY(-50%); z-index: 100;
                    .ts{ .ib-list;  .w(100%); white-space: nowrap;
                      li{ .wh(33.3%,400px);  transition: .5s;
                        a{.block; .wh(100%); .contain; .no-repeat; .bg-y(100%);}
                        &.off{opacity: .5;}
                      }
                    }
                    .desc{.wh(100%,300px); .contain; .no-repeat; .mt(30px); }
                  }

                  &.item0{
                    .bg{.cover; .bg-x(0%;);}
                  }
                  &.item1{
                    article{.r(0); .l(20%);}
                    .bg{.cover; .bg-x(100%;);}
                  }
                  &.item2{
                    .bg{.cover; .bg-x(0%;);}
                  }
                  &.item3{
                    .bg{.cover; .bg-x(0%;);}
                  }
                }
              }
            }
            .begin{.abs; .wh(100%);  z-index:10; .cover("@{pc}/p5/bg1.jpg");
              ul{.ib-list; .abs; .l(50%); .t(50%); transform: translate(-50%,-55%); white-space: nowrap;
                &:before{.cnt; .contain("@{pc}/p5/title.png"); .wh(186px,75px); .mh-c; .mb(40px);}
                li{.rel; .wh(273px,399px); .no-repeat; .m(0,6px);  box-shadow: 0 15px 15px 5px rgba(0,0,0,0.7); .-a(rgba(0,0,0,1),1px);
                  .name{.wh(144px,120px); overflow: hidden;.abs; .no-repeat; transition: .5s; z-index:10; .l(50%); .ml(-72px); .b(0); pointer-events: none;}
                  .thumb{ .abs; overflow:hidden; .wh(100%); &:before{.cnt; .abs; .wh(100%); .bg-c; transition:.5s; .l(50%); .t(50%); transform: translate(-50%,-50%);}}
                  &:nth-of-type(1){
                    .name{ .bg("@{pc}/p5/name1.png");}
                    .thumb{&:before{.contain("@{pc}/p5/thumb1.png");}}
                  }
                  &:nth-of-type(2){
                    .name{ .bg("@{pc}/p5/name2.png");}
                    .thumb{&:before{.contain("@{pc}/p5/thumb2.png");}}
                  }
                  &:nth-of-type(3){
                    .name{ .bg("@{pc}/p5/name3.png");}
                    .thumb{&:before{.contain("@{pc}/p5/thumb3.png");}}
                  }
                  &:nth-of-type(4){
                    .name{ .bg("@{pc}/p5/name4.png");}
                    .thumb{&:before{.contain("@{pc}/p5/thumb4.png");}}
                  }
                  a{.block; .wh(100%);.rel; opacity:0;  transition: .5s; .-box;
                    &:before{.cnt; .wh(68px,46px); .contain("@{pc}/thumb-on-effect.png"); .abs; .t(-25px); .l(100px); opacity: 0; transition: .5s;}
                    &:after{.cnt; .wh(68px,46px); .contain("@{pc}/thumb-on-effect.png"); .abs; .b(-23px); .r(100px); opacity: 0; transition: .5s;}
                  }
                  &:hover{
                    .thumb{&:before{.wh(110%);}}
                    a{ opacity:1; .-a(#FF0000);
                      &:before{.l(10px); opacity: 1;}
                      &:after{.r(10px); opacity: 1;}
                    }
                    &:nth-of-type(1){
                      .name{ .bg("@{pc}/p5/name1-on.png");}
                    }
                    &:nth-of-type(2){
                      .name{ .bg("@{pc}/p5/name2-on.png");}
                    }
                    &:nth-of-type(3){
                      .name{ .bg("@{pc}/p5/name3-on.png");}
                    }
                    &:nth-of-type(4){
                      .name{ .bg("@{pc}/p5/name4-on.png");}
                    }
                  }
                }
              }
            }
            .bg{.cover("@{pc}/p5/bg1.jpg"); .bg-x(50%;);}

            @media screen and (max-width: @screen-xxl-min){
              .list{
                li{.wh(220px,322px);}
              }
            }
          }
        }
      }

      .tab-bts{ .h(45);
        ul{
          li{
            a{.block;.wh(100%);}
            &:nth-of-type(1){.contain("@{pc}/p5/btn-tab1.png"); .wh(182px,100%); .l(0px);
              &:hover,&.on{.contain("@{pc}/p5/btn-tab1-on.png");}
            }
            &:nth-of-type(2){.contain("@{pc}/p5/btn-tab2.png"); .wh(208px,100%); .l(174px);
              &:hover,&.on{.contain("@{pc}/p5/btn-tab2-on.png");}
            }
            &:nth-of-type(3){.contain("@{pc}/p5/btn-tab3.png"); .wh(174px,100%); .l(374px);
              &:hover,&.on{.contain("@{pc}/p5/btn-tab3-on.png");}
            }
            &:nth-of-type(4){.contain("@{pc}/p5/btn-tab4.png"); .wh(208px,100%); .l(540px);
              &:hover,&.on{.contain("@{pc}/p5/btn-tab4-on.png");}
            }
          }
        }
      }
      @media screen and (max-width: @screen-xxl-min){
        .tab-bts{
          ul{
            li{
              &:nth-of-type(1){.wh(121px,100%);}
              &:nth-of-type(2){.wh(139px,100%); .l(116px);}
              &:nth-of-type(3){.wh(116px,100%); .l(250px);}
              &:nth-of-type(4){.wh(139px,100%); .l(361px);}
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pageE.vue